/**
 * Enumのラベル取得関数を生成するファクトリ
 *
 * @param labels - キーと日本語ラベルのマッピングオブジェクト
 * @param defaultLabel - マッチしない場合のデフォルト値
 * @returns ラベル取得関数
 */
export const createEnumTranslator = <T extends Record<string, string>>(
  labels: T,
  defaultLabel: string = ''
) => {
  return (key: string | null | undefined): string => {
    if (!key || !(key in labels)) {
      return defaultLabel;
    }
    return labels[key as keyof T];
  };
};
